import { Injectable } from '@angular/core';
import { MtmAuto } from "mtm-auto";
import { MtmWsEdge } from "mtm-ws-edge";
import { Nodes } from "./Factories/Nodes";

@Injectable({
	providedIn: 'root'
})
export class MtmWsSync
{
	private _nodeFact=null;
	
	constructor(
			private _mtmAuto: MtmAuto,
			private _mtmWsRouter: MtmWsEdge
	) {
		this._mtmAuto.set("ws-sync", this);
	}
	public getAuto()
	{
		return this._mtmAuto;
	}
	public getNodes()
	{
		if (this._nodeFact === null) {
			this._nodeFact	= new Nodes();
			this._nodeFact.setAuto(this.getAuto());
		}
		return this._nodeFact;
	}
}